import { render, staticRenderFns } from "./drafts.vue?vue&type=template&id=1db1f5e7&"
import script from "./drafts.vue?vue&type=script&lang=ts&"
export * from "./drafts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports